import { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Scale } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { LEGAL } from "@/content/legal";
import { useSEO } from "@/hooks/useSEO";

export default function LegalPage() {
  const { slug } = useParams();
  const doc = LEGAL[slug];
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  useSEO({
    title: doc ? `${doc.title} | IND RIL` : "Legal | IND RIL",
    description: doc?.intro?.slice(0, 155),
    path: `/legal/${slug}`,
  });

  if (!doc) return <Navigate to="/legal/terms" replace />;

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <Header />
      <main className="mx-auto max-w-3xl px-6 pt-32 pb-24">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-white/50 hover:text-white"><ArrowLeft className="h-4 w-4" /> Back to home</Link>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}>
          <h1 className="font-display text-4xl font-semibold tracking-tight sm:text-5xl" data-testid="legal-title">{doc.title}</h1>
          <p className="mt-3 text-sm text-white/40">{doc.updated}</p>
          <p className="mt-6 text-white/70">{doc.intro}</p>

          {!doc.final && (
          <div className="mt-6 flex items-start gap-3 rounded-2xl border border-amber-300/20 bg-amber-300/5 p-4 text-sm text-amber-200/90">
            <Scale className="mt-0.5 h-4 w-4 flex-shrink-0" />
            This document is provided for information and should be reviewed by a qualified Indian technology/privacy lawyer before final launch.
          </div>
          )}

          <div className="mt-10 space-y-8">
            {doc.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display text-xl font-semibold text-white">{s.h}</h2>
                {s.p.map((para, j) => (<p key={j} className="mt-2 leading-relaxed text-white/60">{para}</p>))}
              </section>
            ))}
          </div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
